// hooks/useFloors.ts
import { useEffect, useState } from 'react'
import { getMapData, Floor as MappedinFloorRaw } from '@mappedin/mappedin-js'
import { any } from 'numeric'
import { StringLiteralLike } from 'typescript'
import { getBeaconsRaw } from 'models/api'
import { getRequest } from 'models/api/rest'
import { API_BEACONS } from 'lib/constants'
import { MIOptions } from 'lib/utils/mappedin'

type MappedinFloor = {
  id: string
  name: string
  // shortName?: string
  elevation?: number
  externalId?: string
}


type ReactMobileFloor = string

export function useMappedInFloors(options: MIOptions | null | undefined) {
  const [floors, setFloors] = useState<MappedinFloor[]>([])
  
  useEffect(() => {
    const fetchFloors = async () => {
      try {
        if (!options) return
        const mapData = await getMapData(options)
        const sdkFloors = mapData.getByType('floor') as MappedinFloorRaw[]

        const parsed: MappedinFloor[] = sdkFloors.map(f => ({
          id: f.id,
          name: f.name,
          // shortName: f.shortName,
          elevation: f.elevation,
          externalId: f.externalId,
        }))

        setFloors(parsed)
      } catch (err) {
        console.error('Failed to load Mappedin floors:', err)
      }
    }

    if (options) fetchFloors()
  }, [])

  return floors
}

export function useReactMobileFloors( orgId: string) {
  const [floors, setFloors] = useState<ReactMobileFloor[]>([])

  useEffect(() => {
    const fetchBeacons = async () => {
      try {
        const res = await getRequest({ endpoint: `${API_BEACONS}`, header: {org_id: orgId}})
        const data = res.data.data
  
        const uniqueFloors: string[] = Array.from(
          new Set(
            data
              .map((b: any) => b.attributes?.floor)
              .filter((f: any): f is string => typeof f === 'string' && f.trim().length > 0)
              .map((f: any) => f.trim().toLowerCase())
          )
        )

        setFloors(uniqueFloors)
      } catch (err) {
        console.error('Failed to load React Mobile floors from beacons:', err)
      }
    }

     fetchBeacons()
  }, [])

  return floors
}
